import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function AuthCallback() {
  const { exchangeGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        await exchangeGoogle(sessionId);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard");
      } catch (err) {
        const detail = err.response?.data?.detail;
        if (detail === "NO_REP_ACCOUNT") {
          navigate("/register", { state: { googleBlocked: true } });
          return;
        }
        navigate("/login");
      }
    })();
  }, [exchangeGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A1A1A]">
      <div className="text-center">
        <div className="font-display text-3xl tracking-tight mb-3 animate-pulse">
          SECURING YOUR ACCESS…
        </div>
        <div className="overline text-white/40">Authenticating with Google</div>
      </div>
    </div>
  );
}
